<template>
    <div class="administrative-page-welcome">
        <app-title text="Bienvenido al módulo administrativo de Bitacorapp" />
    </div>
</template>
<script>
    import Title from '../../UI/Layout/Title.vue';
    export default {
        components: {
            appTitle: Title
        }
    }
</script>
